import { isAdvertiser } from '~/helpers'

import { useIsManagedByVtex } from './useIsManagedByVtex'

/**
 * Advertiser wallet surfaces (detail + movimentations): origins UI only when
 * the session is managed by VTEX (PI model).
 */
export const useShowWalletOrigins = () => {
  const { isManagedByVtex } = useIsManagedByVtex()

  return isAdvertiser() && isManagedByVtex
}

/**
 * Shared wallets list: same gate as detail — advertisers managed by VTEX only.
 */
export const useShowWalletOriginsColumn = useShowWalletOrigins
